import styled from "styled-components";
import { Tabs } from "@chakra-ui/react";
import { IoLocationOutline } from "react-icons/io5";
import { PiIdentificationCard } from "react-icons/pi";
import { MdBookmarkBorder } from "react-icons/md";
import AddressSearch from "./address-search";
import IdSearch from "./id-search";
import ParcelNumberSearch from "./parcel-number-search";
import { useSearchParams } from "react-router";
import { useEffect, useState } from "react";
import { useUpdateQueryParam } from "../../utils/navigation";
import { responsive } from "../../media-quries";

const Container = styled.div`
  transition: all 0.2s;
  position: relative;
  width: 100%;
  z-index: 999;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.2); /* Półprzezroczyste tło */
  backdrop-filter: blur(5px); /* Rozmycie tła */
  -webkit-backdrop-filter: blur(5px); /* Obsługa dla Safari */
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.5); /* Delikatny cień */

  ${responsive.sm`
    margin-top: 180px;
  `};

  ${responsive.md`
    margin-top: 80px;
  `};

  @media (max-width: 480px) {
    margin-top: 280px;
  };

  @media (max-width: 400px) {
    margin-top: 380px;
  };
`;

const StyledTabs = styled(Tabs.List)`
  flex-wrap: wrap;
  justify-content: center;
`;

const Title = styled.h2`
  position: absolute;
  width: 100%;
  top: -50px;
  left: 0;
  right: 0;
  text-align: center;
  text-transform: uppercase;
  font-size: 26px;
  font-weight: 900;
  text-shadow: 0 0 4px rgba(245, 245, 245, 1);

  ${responsive.sm`
    top: -80px;
  `}
`;

function SearchBar({ searching }) {
    const [searchParams] = useSearchParams();
    const searchBy = searchParams.get("searchBy");
    const [tab, setTab] = useState(searchBy || "address");
    const updateQueryParams = useUpdateQueryParam();

    useEffect(() => {
        if (searchBy) {
            setTab(searchBy);
        }
    }, [searchBy]);

    useEffect(() => {
        // Dodajemy dynamiczny arkusz stylów tylko, gdy nie korzystamy z React Snap
        if (
            !navigator.userAgent.includes("ReactSnap") &&
            !document.getElementById("homeHeaderStyle")
        ) {
            const style = document.createElement("style");
            style.id = "homeHeaderStyle";
            style.innerHTML = `.home-header-section { opacity: 1 !important; }`;
            document.head.appendChild(style);
        }
    }, []);


    return (
        <Container className="home-header-section" style={{ opacity: 0 }}>
            <Title>Wyszukiwarka ksiąg wieczystych</Title>
            <Tabs.Root
                value={tab}
                onValueChange={(e) => {
                    setTab(e.value);
                    updateQueryParams("searchBy", e.value);
                }}
                defaultValue="address"
                variant="searchBar"
            >
                <StyledTabs>
                    <Tabs.Trigger value="address">
                        <IoLocationOutline size={24} />
                        Po Adresie
                    </Tabs.Trigger>
                    <Tabs.Trigger value="id">
                        <PiIdentificationCard size={24} />
                        Po identyfikatorze działki
                    </Tabs.Trigger>
                    <Tabs.Trigger value="number">
                        <MdBookmarkBorder size={24} />
                        Po numerze działki
                    </Tabs.Trigger>
                </StyledTabs>
                <Tabs.Content value="address">
                    <AddressSearch searching={searching} />
                </Tabs.Content>
                <Tabs.Content value="id">
                    <IdSearch searching={searching} />
                </Tabs.Content>
                <Tabs.Content value="number">
                    <ParcelNumberSearch searching={searching} />
                </Tabs.Content>
            </Tabs.Root>
        </Container>
    );
}

export default SearchBar;
